import axios from '~/utils/axios';

export const deleteTeamMember = (id: string) => {
  return axios.delete<void>(`/team/${id}`).then((res) => res.data);
};

export const reset2FA = (id: string) => {
  return axios.post<void>(`/team/${id}/resetMfa`).then((res) => res.data);
};

export const force2FA = (id: string) => {
  return axios.post<void>(`/team/${id}/forceMfa`).then((res) => res.data);
};

export const enableIdentity = (id: string) => {
  return axios.post<void>(`/team/${id}/enable`).then((res) => res.data);
};

export const disableIdentity = (id: string) => {
  return axios.post<void>(`/team/${id}/disable`).then((res) => res.data);
};

export const resetPassword = (id: string) => {
  return axios.post<void>(`/team/${id}/resetPassword `).then((res) => res.data);
};
